import React, { useState } from "react";
import styled from "styled-components";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 50px;
  width: 100%;
`;

const WrapperSearch = styled.div`
  width: 40%;
  margin-top: 10px;
  @media  screen and (max-width: 1024px){
    width: 80%;
  }
`;

const Input = ({
  pokesList,
  elRef,
  setSelectedPoke,
  pokes,
  expanded,
  setExpanded,
}) => {

  const handleOnSelect = (item) => {
    // the item selected
    const index = pokesList?.findIndex(
      (poke) => poke.name.toLowerCase() === item?.name.toLowerCase()
    );
    elRef.current[index].scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
    elRef.current[index].focus();
    setSelectedPoke(pokes[item.id]);
    let copy = [...expanded];
    copy[index] = !expanded[item.id];
    setExpanded(copy);
    setTimeout(() => {
      setSelectedPoke(null);
    }, 3000);
  }

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          <img
            alt={item.poke.name}
            style={{ marginRight: "5px", width: "20px" }}
            src={item.poke.image}
          />
          {item.name}
        </span>
      </>
    );
  }

  return (
    <MainDiv>
      <label>Procure pelo Pokemon</label>
      <WrapperSearch>
        <ReactSearchAutocomplete
          items={pokesList}
          onSelect={handleOnSelect}
          autoFocus
          formatResult={formatResult}
          styling={{
            searchIconMargin: "10px 12px 0 11px",
            clearIconMargin: "3px 8px 0 0",
            zIndex: 1000
          }}
          showIcon={false}
          showNoResults={true}
          showNoResultsText={"Nenhum pokemon foi encontrado."}
        />
      </WrapperSearch>
    </MainDiv>
  );
};

export default Input;